export const AlertType= Object.freeze({ RED: 1, GREEN: 2, BLUE: 3, YELLOW: 4 });
export const AlertStatus= Object.freeze({ PENDING: 1, ATTENDED: 2, EXPIRED: 3});
export const zoomlevels= Object.freeze([{
    name: 'LOW',
    value: 3  
  },
  {
    name: 'MEDIUM',
    value: 5  
  },
  {
    name: 'HIGH',
    value: 9  
  }]);